module.exports = __webpack_public_path__ + "media/images/vip-table-978651b4c58d5ef3b944889e8f62fb5a.svg";